import { BsEye } from "react-icons/bs";
import { FaXmark } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";

export const PpaSummaryCard = ({ src, alt, title, amount }) => {
  return (
    <main className="tw-w-fit tw-h-auto tw-bg-transparent tw-border tw-border-black/10 tw-rounded-lg tw-p-4 tw-flex tw-flex-col tw-items-start">
      <div className="tw-w-12 tw-h-12 tw-bg-black/5 tw-rounded-lg tw-p-3">
        <img src={src} alt={alt} className="tw-w-auto" />
      </div>

      <div className="tw-whitespace-nowrap tw-mt-2 tw-text-black tw-text-sm">
        {" "}
        {title}
      </div>

      <div className="tw-whitespace-nowrap tw-font-semibold tw-text-2xl">
        {" "}
        {amount ? "MUR " + amount.toLocaleString() : 0}{" "}
      </div>
    </main>
  );
};

export const PpaPolicyCard = ({
  headline,
  polNumTitle,
  polNum,
  totalPrem,
  totalPremTitle,
  ppaAmount,
  ppaAmountTitle,
  polStatusTitle,
  polStatus,
  polDate,
  polDateTitle,
  view,
}) => {
  const policyCardContent = [
    {
      id: 0,
      head: polNumTitle,
      value: polNum,
    },
    {
      id: 1,
      head: totalPremTitle,
      value: totalPrem,
    },
    {
      id: 2,
      head: ppaAmountTitle,
      value: ppaAmount,
    },
    {
      id: 3,
      head: polStatusTitle,
      value: polStatus,
    },
    {
      id: 4,
      head: polDateTitle,
      value: polDate,
    },
  ];

  return (
    <div className="tw-bg-black/5 tw-border tw-border-black/5 tw-rounded-lg tw-p-1 tw-h-auto tw-w-[280px]">
      <span className="tw-capitalize tw-p-2 tw-text-lg tw-font-normal tw-flex tw-items-center tw-justify-between tw-gap-2">
        {headline}
        <span className="tw-bg-white tw-border tw-rounded-full tw-w-6 tw-h-6"></span>
      </span>

      <div className="tw-bg-white tw-rounded-lg tw-w-full tw-h-full tw-py-4 tw-pl-6 tw-pr-2 tw-space-y-4">
        {policyCardContent?.map((content) => (
          <div key={content.id}>
            <div className="tw-text-sm tw-text-black/30">
              {content.id === 0
                ? content.head !== "Active"
                  ? "Proposal Number"
                  : "Policy Number"
                : content.head}
            </div>
            <div
              className={` ${
                content.id === 3
                  ? "tw-w-fit tw-h-auto tw-py-1 tw-px-3 tw-rounded-md tw-flex tw-items-center tw-justify-center tw-bg-[#1987541A] tw-text-[#198754]"
                  : "tw-bg-none"
              } tw-text-black `}
            >
              {content.value}
            </div>
          </div>
        ))}

        <div className="tw-flex tw-flex-end tw-justify-end">
          <div
            onClick={view}
            className="tw-bg-transparent tw-border tw-border-[#BEC663] tw-text-sm tw-rounded-lg tw-text-[#BEC663] tw-flex tw-items-center tw-gap-x-2 tw-p-2 tw-cursor-pointer"
          >
            <BsEye className="tw-text-[#BEC663]" />
            View Policy
          </div>
        </div>
      </div>
    </div>
  );
};

export const ViewPolicy = ({
  close,
  polNumTitle,
  polNum,
  polTypeTitle,
  polType,
  polStatusTitle,
  polStatus,
  polStart,
  polStartTitle,
  polMatureTitle,
  polMature,
  polPremTitle,
  polPrem,
  polFreqTitle,
  polFreq,
  polOrderTitle,
  polOrder,
  polHolderTitle,
  polHolder,
  polInsurerTitle,
  polInsurer,
  polBenTitle,
  polBen,
  policyStatus,
  application,
  onContinue,
}) => {
  const viewPolicyDetails = [
    {
      id: 0,
      title: polNumTitle,
      value: polNum,
    },
    {
      id: 1,
      title: polTypeTitle,
      value: polType,
    },
    {
      id: 2,
      title: polStatusTitle,
      value: polStatus,
    },
    {
      id: 3,
      title: polStartTitle,
      value: polStart,
    },
    {
      id: 4,
      title: polMatureTitle,
      value: polMature,
    },
    {
      id: 5,
      title: polPremTitle,
      value: polPrem,
    },
    {
      id: 6,
      title: polFreqTitle,
      value: polFreq,
    },
    {
      id: 7,
      title: polOrderTitle,
      value: polOrder,
    },
    {
      id: 8,
      title: policyStatus,
      value: polStatus,
    },
  ];

  const contactDetails = [
    {
      id: 0,
      contactTitle: polHolderTitle,
      contactValue: polHolder,
    },
    {
      id: 1,
      contactTitle: polInsurerTitle,
      contactValue: polInsurer,
    },
    {
      id: 2,
      contactTitle: polBenTitle,
      contactValue: polBen,
    },
  ];

  const navigate = useNavigate();

  const handleContinue = () => {
    if (onContinue) {
      onContinue();
    } else if (application) {
      if (application.status === "underwriting") {
        navigate(`/underwriting/${application.id}/main-life`);
      } else if (application.status === "kyc") {
        navigate(`/client-kyc/${application?.user?.id}/${application.id}/main`);
      } else if (application.status === "review") {
        navigate(`/review/${application.id}`);
      } else if (application.status === "firstpayment") {
        navigate(`/quotations/${application.id}/first-payment`);
      } else if (application.status === "accepted") {
        navigate(
          `/accounts/transactions/${
            application.userJointId
              ? application.userJointId
              : application.userId
          }`
        );
      } else {
        navigate("/application-in-review");
      }
    }
  };

  return (
    <main
      className="tw-font-haas tw-fixed tw-z-20 tw-left-0 tw-top-0 tw-w-screen tw-h-full tw-overflow-auto"
      style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <section className="tw-w-full tw-flex tw-flex-end tw-justify-end tw-overflow-y-auto">
        <div className="tw-bg-white tw-min-w-[50%] md:tw-min-w-[30%] tw-w-auto tw-h-screen tw-p-6 tw-flex tw-flex-col tw-justify-between">
          <div>
            <div className="tw-flex tw-items-center tw-justify-between tw-gap-3">
              <h5 className="tw-font-semibold">Policy Details</h5>

              <FaXmark
                onClick={close}
                className="tw-size-12 tw-cursor-pointer"
              />
            </div>
            <hr />
            {viewPolicyDetails?.map((details) => (
              <section className="tw-capitalize" key={details.id}>
                <div className="tw-px-6 tw-py-1 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-items-center tw-gap-x-3">
                  <div className="tw-col-span-1 tw-text-black/40">
                    {details.title}
                  </div>
                  <div
                    className={` tw-col-span-1 ${
                      details.id === 8
                        ? "tw-w-fit tw-h-auto tw-px-3 tw-py-2 tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-bg-[#1987541A] tw-text-[#198754]"
                        : "tw-text-black"
                    }`}
                  >
                    {details.value}
                  </div>
                </div>
              </section>
            ))}

            <div className="tw-font-semibold tw-mt-8">Contact Parties</div>
            <hr />

            {contactDetails?.map((details) => (
              <section
                key={details.id}
                className="tw-px-6 tw-py-1 tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-items-center tw-gap-x-3"
              >
                <div className="tw-col-span-1 tw-text-black/40">
                  {details.contactTitle}
                </div>
                <div className="tw-col-span-1">{details.contactValue}</div>
              </section>
            ))}
          </div>

          {application && application.status !== "initial" && (
            <div className="tw-flex tw-flex-end tw-justify-end">
              <button
                onClick={handleContinue}
                className="btn ila-bg text-white"
              >
                {application.status === "accepted"
                  ? "View Transaction History"
                  : "Continue Application"}
              </button>
            </div>
          )}
        </div>
      </section>
    </main>
  );
};
